(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tab-schedule', {
            parent: 'update_management',
            url: '/tab-schedule?page&sort&search',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.tabSchedule.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-schedule/tab-schedules.html',
                    controller: 'TabScheduleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: [],
                    squash:true
                },
                itemsPerPageChosen: null,
                ch: {
                    value: '',
                    squash: true
                },
                firstAccess: {
                    value: true
                },
                predicates : {},
                fleet: {
                    value: '-1'
                },
                objectType: {
                    value: '-1'
                },
                status: {
                    value: '-1'
                },
                from: {
                    value: (function previousYear() {
                        return new Date(new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate());
                    }),
                    squash: true
                },
                to: {
                    value: (function today(){
                        return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
                    }),
                    squash: true
                },
                tag : {
                    value: null
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicates : $stateParams.predicates,
                        ch: $stateParams.ch,
                        fleet: $stateParams.fleet,
                        objectType: $stateParams.objectType,
                        from: $stateParams.from,
                        to: $stateParams.to,
                        status: $stateParams.status,
                        tag: $stateParams.tag,
                        firstAccess: $stateParams.firstAccess
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabSchedule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tab-schedule-detail', {
            parent: 'tab-schedule',
            url: '/tab-schedule/{id}',
            data: {
                authorities: ['ROLE_DOMAIN_USER'],
                pageTitle: 'jotApp.tabSchedule.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/tab-schedule/tab-schedule-detail.html',
                    controller: 'TabScheduleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tabSchedule');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TabSchedule', function($stateParams, TabSchedule) {
                    return TabSchedule.get({id : $stateParams.id});
                }]
            }
        })
        .state('tab-schedule.delete', {
            parent: 'tab-schedule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DOMAIN_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-schedule/tab-schedule-delete-dialog.html',
                    controller: 'TabScheduleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TabSchedule', function(TabSchedule) {
                            return TabSchedule.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tab-schedule', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
